<template>
  <div class="search-item">
    <div
      class="image-container"
      v-if="model.type === 'InstagramUser'"
      :class="{ post: !model.story }"
    >
      <div
        class="image"
        :key="model.image"
        v-lazy:background-image="model.image"
      ></div>
    </div>
    <div class="image-container tag" v-if="model.type === 'InstagramTag'">
      <div class="image"></div>
    </div>
    <div
      class="image-container location"
      v-if="model.type === 'InstagramLocation'"
    >
      <div class="image"></div>
    </div>
    <div class="right-container">
      <div class="first-container">
        <div class="title">{{ model.title }}</div>
        <div v-if="model.verify" class="approve-icon"></div>
      </div>
      <div class="des" v-if="model.des">{{ model.des }}</div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/style/theme.less";
.search-item {
  height: 60px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover,
  &:active {
    background: rgba(0, 0, 0, 0.1);
  }

  .image-container {
    background: linear-gradient(to bottom right, #c6008b, #e1013a);
    height: 48px;
    width: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    &.tag {
      background: white;
      border: 1px solid #cccccc;
      .image {
        background-image: url("../../../public/images/repost/icon_hashtag@3x.png");
      }
    }
    &.location {
      background: white;
      border: 1px solid #cccccc;
      .image {
        background-image: url("../../../public/images/repost/icon_place@3x.png");
      }
    }
    .image {
      height: 44px;
      width: 44px;
      background-size: contain;
      border-radius: 50%;
      border: 2px solid white;
    }

    &.post {
      background: white;

      .image {
        height: 48px;
        width: 48px;
        border-width: 0;
      }
    }
  }

  .right-container {
    flex: 1;
    align-items: center;
    padding: 0 15px;

    .first-container {
      display: flex;
      align-items: center;

      .title {
        font-size: 14px;
        font-weight: 500;
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .approve-icon {
        background-image: url("../../../public/images/schedule_posts/tag_people/approve@3x.png");
        width: 12px;
        height: 12px;
        background-size: contain;
        margin-left: 4px;
        position: relative;
      }
    }

    .des {
      font-size: 14px;
      color: @font-color-gray;
      margin-top: 5px;
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>

<script>
export default {
  name: "SearchItemComponent",
  props: {
    model: { type: Object, required: true }, // 数据
    type: { type: String, required: true }, // 类型
  },
};
</script>
